module.exports = __webpack_public_path__ + "img/funnel-lbpath-2021.a21c06d4.svg";